import * as React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ISelectableMetric, ITest } from '../../../../data/types';
import { useAutoScroll } from '../hooks/useAutoScroll';
import { ScoreboardRankRow } from './ScoreboardRankRow';

interface IProps {
  title: string;
  list: ITest[];
  metric: ISelectableMetric;
  onTestClick: (test: ITest) => void;
  autoScroll?: boolean;
}

export const ScoreboardColumn = ({
  title,
  list,
  metric,
  onTestClick,
  autoScroll = false,
}: IProps): React.ReactElement => {
  const scrollRef = useAutoScroll<HTMLDivElement>({
    enabled: autoScroll,
    listLength: list.length,
  });

  return (
    <Flex
      flex={1}
      direction='column'
      overflow='hidden'
      role='region'
      aria-label={`${title} leaderboard`}
    >
      {list.length > 1 ? (
        <Box
          ref={scrollRef}
          flex={1}
          minH={0}
          overflowY='auto'
          display='flex'
          flexDirection='column'
          gap={1}
          role='list'
          aria-label={
            list.length > 2
              ? `${title} rankings 2 through ${list.length}`
              : `${title} ranking 2`
          }
          css={{
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
          }}
        >
          {list.slice(1).map(
            (test: ITest, index: number): React.ReactElement => (
              <ScoreboardRankRow
                key={test.id}
                test={test}
                rank={index + 2}
                metric={metric}
                onTestClick={onTestClick}
              />
            )
          )}
        </Box>
      ) : (
        <Flex flex={1} align='center' justify='center'>
          <Text
            fontSize='14px'
            color='var(--scoreboard-text-secondary, #b0b0b0)'
          >
            No results
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
